import type {
  ResultList,
  User,
  UsersErrorDTO,
  UserService,
  UserServiceListParams,
} from '@empathyco/playboard-core-domain'
import { ref } from 'vue'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'

const loading = {
  read: ref(false),
  list: ref(false),
}

const data = {
  read: ref<User | undefined>(undefined),
  list: ref<ResultList<User> | undefined>(undefined),
}

const error = {
  read: ref<UsersErrorDTO | undefined>(undefined),
  list: ref<UsersErrorDTO | undefined>(undefined),
}

export function useUsers(): {
  loading: typeof loading
  data: typeof data
  error: typeof error
  read: (id: User['id']) => Promise<void>
  list: (params: UserServiceListParams) => Promise<void>
} {
  const service = CONTAINER.get<UserService>(TYPES.UserService)

  async function read(id: User['id']): Promise<void> {
    loading.read.value = true
    try {
      data.read.value = await service.read(id)
      error.read.value = undefined
    } catch (e) {
      data.read.value = undefined
      error.read.value = e as UsersErrorDTO
    } finally {
      loading.read.value = false
    }
  }

  async function list(params: UserServiceListParams): Promise<void> {
    loading.list.value = true
    try {
      data.list.value = await service.list(params)
      error.list.value = undefined
    } catch (e) {
      data.list.value = undefined
      error.list.value = e as UsersErrorDTO
    } finally {
      loading.list.value = false
    }
  }

  return {
    loading,
    data,
    error,
    read,
    list,
  }
}
